<div class="provider-listing-container" data-test="provider-card">
  <div class="desktop-tablet-photo-container" data-test="photo-container">
    <provider-photo
      [initials]="providerListing.display_name | initials"
      [photoUrl]="providerListing.profile_photo_url"
      [providerName]="providerListing.display_name">
    </provider-photo>
  </div>

  <div class="mobile-id-container">
    <div class="photo-container">
      <provider-photo
        [initials]="providerListing.display_name | initials"
        [photoUrl]="providerListing.profile_photo_url"
        [providerName]="providerListing.display_name">
      </provider-photo>
    </div>

    <div class="mobile-id-panel">
      <div class="name">
        <a
          [href]="profileLinkUrl"
          target="_blank"
          (click)="onClickViewProfile()"
        >
          {{ providerListing.display_name }}
        </a>
        <span class="pronouns" *ngIf="providerListing.pronouns">({{ providerListing.pronouns }})</span>
      </div>
      <div class="certifications">
        <p>
          {{ certifications | stringArrayToCommaList }}
        </p>
      </div>
    </div>
  </div>


  <div class="mobile-bio-panel">
    <pills 
      [pillsData] = "pillsData" 
      [profileLinkUrl]="profileLinkUrl" 
      [specialtyNamesArray]="specialtyNamesArray" />

    <p class="mini-bio" data-test="mini-bio">
      <iris-icon 
        name="quote" 
        colorToken="$color-dec-indigo-100">
      </iris-icon>
      <strong>From {{providerListing.display_first_name}}: </strong>
      <span *ngIf="providerListing.mini_bio">{{ providerListing.mini_bio }}</span>
      <span 
        class="bio" 
        *ngIf="!providerListing.mini_bio" 
        data-test="bio">{{ shortenedBio }}...</span>
    </p>
  </div>

  <div class="desktop-bio-panel">
    <p class="name" data-test="provider-name">
      <a
        [href]="profileLinkUrl"
        target="_blank"
        (click)="onClickViewProfile()"
      >
        {{ providerListing.display_name }}
      </a>
      <span class="pronouns" *ngIf="providerListing.pronouns">({{ providerListing.pronouns }})</span>
    </p>

    <div class="credentials" data-test="credentials">
      <p>
        {{ certifications | stringArrayToCommaList }}
      </p>
    </div>

    
    <pills 
      [pillsData] = "pillsData" 
      [profileLinkUrl]="profileLinkUrl" 
      [specialtyNamesArray]="specialtyNamesArray" />

    <p class="mini-bio" data-test="mini-bio">
        <iris-icon 
          name="quote" 
          colorToken="$color-dec-indigo-100">
        </iris-icon>
        <strong>From {{providerListing.display_first_name}}: </strong>
        <span *ngIf="providerListing.mini_bio">{{ providerListing.mini_bio }}</span>
        <span 
          class="bio" 
          *ngIf="!providerListing.mini_bio" 
          data-test="bio">{{ shortenedBio }}...</span>
    </p>
  </div>

  <div class="mobile-action-panel">
    <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  </div>

  <div class="desktop-action-panel" data-test="action-panel">
    <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  </div>
</div>

<ng-template #actionButtons>
  <div class="soonest-available" *ngIf="providerSoonestAvailability?.soonest_availability">
    <strong class="soonest-available-label">
      Soonest available session <span class="mobile-only">: </span>
    </strong>
    <p class="soonest-available-date">{{ providerSoonestAvailability?.soonest_availability | date:'EEE, MMM d' }}</p>
  </div>

  <div
    *ngIf="providerSoonestAvailability?.loading"
    class="soonest-available-loading shimmer">
  </div>

  <div class="button-container" data-test="action-buttons">
    <a
      [href]="matchLinkUrl"
      target="_blank"
      class="iris-button iris-button--primary request-session"
      (click)="requestSession()"
      attr.aria-label="Request a session with {{ providerListing.display_name }}"
    >
      Request a session
    </a>
    <a
      [href]="profileLinkUrl"
      target="_blank"
      class="iris-button iris-button--secondary view-profile"
      (click)="onClickViewProfile()"
      attr.aria-label="View {{ providerListing.display_name }}'s profile"
    >
      View profile
    </a>
  </div>
</ng-template>
